// Menu data for Délices de Chaumont
// Prices extracted from menu images

export const menuData = {
  // STAR PRODUCTS - Main focus
  crousty: {
    title: "NOS CROUSTY",
    description: "Poulet frit maison croustillant",
    items: [
      {
        id: "crousty-bowl",
        name: "Crousty Bowl",
        description: "Riz basmati, sauce aigre douce sucrée ou épicée, tenders, oignons frits, persil",
        price: 8.50,
        badge: "populaire",
        image: "https://customer-assets.emergentagent.com/job_gourmet-chaumont/artifacts/s3euqovo_IMG_8632.jpeg"
      },
      {
        id: "crousty-menu",
        name: "Crousty Bowl Menu",
        description: "Crousty Bowl + Boisson 33cl",
        price: 9.50,
        badge: null,
        image: null
      }
    ]
  },

  bowls: {
    title: "NOS BOWLS",
    description: "Frais, sains et gourmands avec frites et fromage",
    items: [
      {
        id: "bowl-1v",
        name: "Bowl 1 Viande",
        description: "Frites, fromage fondu, viande au choix",
        price: 7.00,
        badge: null,
        image: "https://customer-assets.emergentagent.com/job_gourmet-chaumont/artifacts/cwjb33eq_IMG_8634.jpeg"
      },
      {
        id: "bowl-2v",
        name: "Bowl 2 Viandes",
        description: "Frites, fromage fondu, 2 viandes au choix",
        price: 9.00,
        badge: "populaire",
        image: null
      },
      {
        id: "bowl-3v",
        name: "Bowl 3 Viandes",
        description: "Frites, fromage fondu, 3 viandes au choix",
        price: 11.00,
        badge: null,
        image: null
      }
    ],
    options: {
      viandes: ["Steak", "Curry", "Tandoori", "Kebab", "Nuggets", "Cordon Bleu", "Tenders", "Poulet nature"],
      supplements: [
        { name: "Fromage supplémentaire", price: 1.00 },
        { name: "Boursin / Chèvre / Vache qui rit / Cheddar", price: 1.00 }
      ]
    }
  },

  tacos: {
    title: "NOS TACOS",
    description: "French Tacos sauce fromagère onctueuse",
    items: [
      {
        id: "tacos-1v",
        name: "Tacos 1 Viande",
        description: "Galette, frites, fromage, sauce, viande au choix",
        price: 7.00,
        badge: null,
        image: "https://customer-assets.emergentagent.com/job_gourmet-chaumont/artifacts/hyc41tkc_IMG_8633.jpeg"
      },
      {
        id: "tacos-2v",
        name: "Tacos 2 Viandes",
        description: "Galette, frites, fromage, sauce, 2 viandes au choix",
        price: 9.00,
        badge: "populaire",
        image: null
      },
      {
        id: "tacos-3v",
        name: "Tacos 3 Viandes",
        description: "Galette, frites, fromage, sauce, 3 viandes au choix",
        price: 11.00,
        badge: null,
        image: null
      },
      {
        id: "tacos-menu",
        name: "Menu Tacos",
        description: "Tacos + Frites + Boisson",
        priceExtra: 1.50,
        badge: null,
        image: null
      }
    ],
    options: {
      viandes: ["Steak", "Curry", "Tandoori", "Kebab", "Nuggets", "Cordon Bleu", "Tenders", "Poulet nature"],
      sauces: ["Ketchup", "Mayonnaise", "Barbecue", "Blanche", "Biggy", "Andalouse", "Algérienne", "Poivre", "Samouraï", "Harissa", "Moutarde"],
      supplements: [
        { name: "Supplément viande/fromage", price: 1.00 }
      ]
    }
  },

  // EXTRAS
  extras: {
    title: "EXTRAS",
    description: "Accompagnements et snacks",
    items: [
      {
        id: "frites",
        name: "Barquette de Frites",
        description: "Frites fraîches maison",
        price: 3.00,
        badge: null,
        image: null
      },
      {
        id: "frites-cheddar",
        name: "Frites Cheddar",
        description: "Frites avec sauce cheddar",
        price: 5.00,
        badge: "populaire",
        image: "https://customer-assets.emergentagent.com/job_gourmet-chaumont/artifacts/qh8c5jcs_IMG_8675.jpeg"
      },
      {
        id: "barquette-viande",
        name: "Barquette de Viande",
        description: "Viande kebab ou poulet",
        price: 5.50,
        badge: null,
        image: null
      },
      {
        id: "nuggets",
        name: "Nuggets x8",
        description: "8 nuggets de poulet croustillants",
        price: 6.90,
        badge: null,
        image: null
      },
      {
        id: "tenders",
        name: "Tenders x6",
        description: "6 tenders de poulet panés",
        price: 6.90,
        badge: null,
        image: null
      },
      {
        id: "mozza-sticks",
        name: "Mozza Sticks x8",
        description: "8 bâtonnets de mozzarella panés",
        price: 6.90,
        badge: null,
        image: null
      },
      {
        id: "onion-rings",
        name: "Oignons Rings x8",
        description: "8 rondelles d'oignons panées",
        price: 6.90,
        badge: null,
        image: null
      },
      {
        id: "wings-4",
        name: "Wings x4",
        description: "4 ailes de poulet épicées",
        price: 5.00,
        badge: null,
        image: null
      },
      {
        id: "wings-8",
        name: "Wings x8",
        description: "8 ailes de poulet épicées",
        price: 9.00,
        badge: null,
        image: null
      }
    ]
  },

  // DESSERTS
  desserts: {
    title: "NOS DESSERTS",
    description: "Douceurs pour finir en beauté",
    items: [
      {
        id: "tiramisu",
        name: "Tiramisu",
        description: "Tiramisu maison crémeux",
        price: 2.90,
        badge: null,
        image: null
      },
      {
        id: "tarte-daim",
        name: "Tarte au Daim",
        description: "Tarte au caramel et chocolat",
        price: 2.90,
        badge: null,
        image: null
      },
      {
        id: "beignets",
        name: "Beignets Trio",
        description: "3 beignets au sucre",
        price: 2.50,
        badge: null,
        image: null
      },
      {
        id: "nutella",
        name: "Nutel'a",
        description: "Crêpe ou gaufre au Nutella",
        price: 3.00,
        badge: null,
        image: null
      },
      {
        id: "chocolat-liegeois",
        name: "Chocolat Liégeois",
        description: "Coupe glacée au chocolat",
        price: 2.90,
        badge: null,
        image: null
      }
    ]
  },

  // BOISSONS
  boissons: {
    title: "NOS BOISSONS",
    description: "Rafraîchissements",
    items: [
      {
        id: "canette",
        name: "Canette 33cl",
        description: "Coca-Cola, Fanta, Oasis, Ice Tea...",
        price: 1.50,
        badge: null,
        image: null
      },
      {
        id: "bouteille-50",
        name: "Bouteille 50cl",
        description: "Eau, Coca, Oasis...",
        price: 2.00,
        badge: null,
        image: null
      },
      {
        id: "bouteille-150",
        name: "Bouteille 1.5L",
        description: "Coca-Cola, Fanta, Oasis...",
        price: 3.00,
        badge: null,
        image: null
      },
      {
        id: "redbull",
        name: "Red Bull",
        description: "Boisson énergisante",
        price: 2.50,
        badge: null,
        image: null
      }
    ]
  },

  // SECONDARY PRODUCTS - Sandwichs, Kebabs, Assiettes, etc.
  sandwichs: {
    title: "NOS SANDWICHS",
    description: "Pain maison ou Tortilla",
    items: [
      {
        id: "sandwich-kebab",
        name: "Kebab",
        description: "Viande de kebab",
        price: 7.00,
        priceMenu: 8.50,
        badge: null,
        image: null
      },
      {
        id: "sandwich-chicken-curry",
        name: "Chicken Curry",
        description: "Filet de poulet mariné au curry",
        price: 7.00,
        priceMenu: 8.50,
        badge: null,
        image: null
      },
      {
        id: "sandwich-tenders",
        name: "Tenders",
        description: "Tenders + cheddar",
        price: 7.00,
        priceMenu: 8.50,
        badge: null,
        image: null
      },
      {
        id: "sandwich-chicken-tandoori",
        name: "Chicken Tandoori",
        description: "Filet de poulet mariné au tandoori",
        price: 7.00,
        priceMenu: 8.50,
        badge: null,
        image: null
      },
      {
        id: "sandwich-magistral",
        name: "Le Magistral",
        description: "Filet de poulet mariné au curry, steak, cheddar",
        price: 7.50,
        priceMenu: 8.90,
        badge: "populaire",
        image: null
      },
      {
        id: "sandwich-buffalo",
        name: "Buffalo",
        description: "4 steaks 45g + cheddar",
        price: 7.50,
        priceMenu: 8.90,
        badge: null,
        image: null
      },
      {
        id: "sandwich-delice",
        name: "Le Délice",
        description: "2 viandes au choix + cheddar",
        price: 7.50,
        priceMenu: 8.90,
        badge: "maison",
        image: null
      },
      {
        id: "sandwich-gourmand",
        name: "Le Gourmand",
        description: "Cordon bleu + steak 45g + cheddar",
        price: 7.50,
        priceMenu: 8.90,
        badge: null,
        image: null
      },
      {
        id: "sandwich-boursin",
        name: "Boursin",
        description: "Escalope de poulet boursin + cheddar",
        price: 7.50,
        priceMenu: 8.90,
        badge: null,
        image: null
      },
      {
        id: "sandwich-merguez",
        name: "Merguez",
        description: "2 merguez + cheddar",
        price: 7.00,
        priceMenu: 8.90,
        badge: null,
        image: null
      }
    ]
  },

  assiettes: {
    title: "NOS ASSIETTES",
    description: "Assiettes généreuses servies avec frites et salade",
    items: [
      {
        id: "assiette-kebab",
        name: "Assiette Kebab",
        description: "Viande kebab, frites, salade, sauce",
        price: 9.50,
        badge: null,
        image: null
      },
      {
        id: "assiette-curry",
        name: "Assiette Chicken Curry",
        description: "Poulet curry, frites, salade, sauce",
        price: 9.50,
        badge: null,
        image: null
      },
      {
        id: "assiette-tandoori",
        name: "Assiette Tandoori",
        description: "Poulet tandoori, frites, salade, sauce",
        price: 9.50,
        badge: null,
        image: null
      },
      {
        id: "assiette-delices",
        name: "Assiette Délices",
        description: "Mix de viandes, frites, salade, sauce",
        price: 10.50,
        badge: "maison",
        image: null
      },
      {
        id: "assiette-royal",
        name: "Assiette Royal",
        description: "Mix royal de viandes, frites, salade, sauce",
        price: 10.50,
        badge: null,
        image: null
      },
      {
        id: "assiette-merguez",
        name: "Assiette Merguez",
        description: "3 merguez, frites, salade, sauce",
        price: 10.50,
        badge: null,
        image: null
      }
    ]
  },

  burgers: {
    title: "NOS BURGERS",
    description: "Burgers maison généreux",
    items: [
      {
        id: "burger-cheese",
        name: "Cheese Burger",
        description: "1 steak 45g + cheddar + crudités",
        price: 4.00,
        priceMenu: 5.50,
        badge: null,
        image: null
      },
      {
        id: "burger-double-cheese",
        name: "Double Cheese",
        description: "2 steaks 45g + 2 cheddars + crudités",
        price: 5.00,
        priceMenu: 6.90,
        badge: "populaire",
        image: null
      },
      {
        id: "burger-triple-cheese",
        name: "Triple Cheese",
        description: "3 steaks 45g + 3 cheddars + crudités",
        price: 6.00,
        priceMenu: 7.90,
        badge: null,
        image: null
      },
      {
        id: "burger-chicken",
        name: "Chicken Burger",
        description: "2 tenders + 2 cheddars + crudités",
        price: 6.00,
        priceMenu: 7.90,
        badge: null,
        image: null
      },
      {
        id: "burger-fish",
        name: "Fish Burger",
        description: "Filet de poisson pané + crudités",
        price: 4.50,
        priceMenu: 6.00,
        badge: null,
        image: null
      },
      {
        id: "burger-double-fish",
        name: "Double Fish",
        description: "2 filets de poisson panés + cheddar + crudités",
        price: 5.50,
        priceMenu: 7.50,
        badge: null,
        image: null
      }
    ]
  },

  salades: {
    title: "NOS SALADES",
    description: "Salades fraîches et légères",
    items: [
      {
        id: "salade-poulet",
        name: "Salade Poulet",
        description: "Salade, tomates, maïs, mozzarella, poulet, croûtons",
        price: 6.90,
        badge: null,
        image: null
      },
      {
        id: "salade-chevre",
        name: "Salade Chèvre",
        description: "Salade, tomates, maïs, mozzarella, chèvre, croûtons",
        price: 6.90,
        badge: null,
        image: null
      }
    ]
  },

  menuEnfant: {
    title: "MENU ENFANT",
    description: "Pour les petits gourmands",
    items: [
      {
        id: "menu-enfant",
        name: "Menu Enfant",
        description: "5 nuggets, frites, boisson, dessert",
        price: 6.50,
        badge: null,
        image: null
      }
    ]
  }
};

export const restaurantInfo = {
  name: "Délices de Chaumont",
  phone: "03 60 36 11 65",
  phoneLink: "tel:+33360361165",
  address: "10 Rue Roger Blondeau",
  city: "60240 Chaumont-en-Vexin",
  region: "Hauts-de-France, France",
  
  hours: {
    monday: { lunch: "11:00 - 14:00", dinner: "18:00 - 22:00" },
    tuesday: { lunch: "11:00 - 14:00", dinner: "18:00 - 22:00" },
    wednesday: { lunch: "11:00 - 14:00", dinner: "18:00 - 22:00" },
    thursday: { lunch: "11:00 - 14:00", dinner: "18:00 - 22:00" },
    friday: { lunch: "11:00 - 14:00", dinner: "18:00 - 22:00" },
    saturday: { lunch: null, dinner: "18:00 - 22:00" },
    sunday: { lunch: null, dinner: "18:00 - 22:00" }
  },
  
  googleMapsLink: "https://share.google/e7dPqTTIabEvziSc9",
  
  features: [
    { icon: "CreditCard", text: "Cartes de crédit acceptées" },
    { icon: "Ticket", text: "Tickets restaurant acceptés" },
    { icon: "Banknote", text: "Espèces" },
    { icon: "UtensilsCrossed", text: "Sur place" },
    { icon: "ShoppingBag", text: "À emporter" },
    { icon: "Accessibility", text: "Accès personnes handicapées" }
  ],
  
  nearbyAreas: [
    "Île-de-France",
    "Hauts-de-France", 
    "Gisors",
    "Loconville",
    "Liancourt-Saint-Pierre",
    "Trie-Château"
  ],
  
  delivery: {
    minimum: 15.00,
    minimumOutside: 35.00,
    freeFrom: 15.00
  }
};
